import { createSelector } from '@reduxjs/toolkit';
const profileSelector = (state) => state.profile;
const usernameSelector = (_, username) => username;
export const showPrivateProfileSelector = createSelector([profileSelector, usernameSelector], (profile, username) => {
    return profile.isLoggedIn && profile.username === username;
});
export const profileSummarySelector = createSelector([showPrivateProfileSelector, profileSelector], (showPrivateProfile, profile) => {
    return showPrivateProfile ? profile.profileSummary.private : profile.profileSummary.public;
});
export const privateProfileSummarySelector = createSelector([profileSelector], (profile) => {
    return profile.profileSummary.private;
});
export const isLoggedInProfileSelector = createSelector([profileSelector], (profile) => {
    return profile.isLoggedIn;
});
export const authenticatedProfileSelector = createSelector([profileSelector], (profile) => {
    return profile.profileAuth.account;
});
export const usernameProfileSelector = createSelector([profileSelector], (profile) => {
    return profile.username;
});
